enum FeatureFlags {
  CART_HAMS_CCP_OPEN_QUOTE_MIGRATION = 'cart-hams-ccp-open-quote-migration',
  CART_RENAME_ATLASSIAN_ACCESS_TO_GUARD = 'cart-rename-atlassian-access-to-guard',
  CART_MAC_MIGRATION_ENABLE_CCP_SEARCH_CALL = 'cart-mac-migration-enable-ccp-search-call',
  MIGRATION_CLOUDS_BANNER_FOR_PARTNERS = 'migration_clouds_baner_for_partners',
  CART_MAINTENANCE_BANNER = 'cart-maintenance-banner',
  CART_LIMIT_DC_MULTI_YEAR_CONTRACTS = 'cart-limit-dc-multi-year-contracts',
  CLOUD_MIGRATION_TRIAL_LINK = 'cloud_migration_trial_cta_enabled',
  CART_SHOW_APPLICATION_FORM_TEXT_IN_PAY_ON_TERMS = 'cart-show-application-form-text-in-pay-on-terms',
  CART_EGYPT_TAX_EXEMPTIONS_FIELD = 'cart-egypt-tax-exemption-field',
  CART_VAT_LABELS_FOR_THAILAND = 'enable_vat_labels_for_thailand',
  CART_ENABLE_DC_EOL_BANNER = 'cart-enable-dc-eol-banner',
}

export default FeatureFlags;
